import React, { useEffect, useState } from 'react'
import Search from '../components/Search'
import SortControls from '../components/SortControls'
import ContentGrid from '../components/ContentGrid'
import { normalizeString } from '../utils/helpers'
import { getTitlesDb, onTitlesUpdated } from '../utils/contentRepository'

const TitlesView = ({ language }) => {
  const [titlesDb, setTitlesDb] = useState(() => getTitlesDb())
  const [searchTerm, setSearchTerm] = useState('')
  const [sortBy, setSortBy] = useState('name')
  const [sortOrder, setSortOrder] = useState('asc')

  useEffect(() => onTitlesUpdated(setTitlesDb), [])

  const currentTitleBase = language === 'EN' ? titlesDb.EN : titlesDb.RU

  const resetFilters = () => {
    setSortBy('name')
    setSortOrder('asc')
    setSearchTerm('')
  }

  const filteredTitles = currentTitleBase
    .filter((item) =>
      normalizeString(item).includes(normalizeString(searchTerm))
    )
    .sort((a, b) =>
      sortOrder === 'asc' ? a.localeCompare(b) : b.localeCompare(a)
    )

  return (
    <>
      <Search
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        language={language}
      />
      <SortControls
        activeView="titles"
        sortBy={sortBy}
        setSortBy={setSortBy}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        resetFilters={resetFilters}
        filteredCount={filteredTitles.length}
        totalCount={currentTitleBase.length}
        language={language}
      />
      <ContentGrid
        activeView="titles"
        data={filteredTitles}
        language={language}
      />
    </>
  )
}

export default TitlesView
